import React, { useState } from "react";
import { PasswordInput, TextInput } from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { facilityAction } from "../../_store";
import { useLocation } from "react-router-dom";
//import { decryptData } from "../../utils/encryptDecrypt";
import { facilitySchema } from "../../validation/facilitySchema";

function FTPPermission({ errorMessage, setErrorMessage }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);

  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);
  const facilityID = location?.state ? location?.state?.facilityID : 0;

  const handleChange = (e) => {
    let facilityData = { ...facilityInformationData };
    const { name, value } = e?.target;
    if (name === "FTPUserName") {
      facilityData["FTPUserName"] = value.replace(/[^a-zA-Z0-9_]/g, "");
    } else if (name === "FTPServerURL") {
      facilityData["FTPServerURL"] = value.replace(/[^0-9.]/g, "");
    } else if (name === "FTPFilePath") {
      facilityData["FTPFilePath"] = value.replace(/[^a-zA-Z0-9\/._-]/g, "");
    } else {
      facilityData[name] = value;
    }
    dispatch(facilityAction?.setFacilityData(facilityData));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleBlurFTPInfo = async (e) => {
    let facilityData = { ...facilityInformationData };
    let { name, value } = e.target;
    try {
      // Clear error if validation passes
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "", // Clear the specific field error
      }));

      facilityData[name] = value ? value.trim() : "";
      dispatch(facilityAction?.setFacilityData(facilityData));
      // Validate the field using the Joi schema and handle both required and other validation
      let objField = { [name]: value };

      await facilitySchema.validateAsync(
        {
          ...objField,
          InmateUploadType: facilityInformationData?.InmateUploadType,
        },
        { abortEarly: false }
      );
    } catch (err) {
      // Find the error that matches the current field name
      const fieldError = err.details.find((error) => error.path.includes(name));

      if (fieldError) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError.message, // Set the specific field error from Joi
        }));
      }
    }
  };

  return (
    <div className="mt-3 mb-3">
      <h4
        className="inner-header-bg text-color"
        style={{ cursor: "pointer" }}
        title="To import the inmates from the given path detail"
      >
        <i className="fas fa-globe me-2"></i>FTP Information{" "}
      </h4>
      <div className="row mb-4">
        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <TextInput
              name="FTPServerURL"
              id="server_url"
              label="Server URL"
              value={facilityInformationData.FTPServerURL}
              // handleChange={handleChange}
              placeholder="192.168.1.1"
              required
              errorMessage={errorMessage}
              handleChange={handleChange}
              handleBlur={handleBlurFTPInfo}
              maxLength={100}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <TextInput
              name="FTPFilePath"
              id="file_path"
              label="File Path"
              value={facilityInformationData.FTPFilePath}
              placeholder="/FilePath/FileName.txt"
              required
              errorMessage={errorMessage}
              handleChange={handleChange}
              handleBlur={handleBlurFTPInfo}
              maxLength={50}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <TextInput
              name="FTPUserName"
              id="username"
              label="Username"
              value={facilityInformationData.FTPUserName}
              placeholder="Enter Username"
              required
              errorMessage={errorMessage}
              handleChange={handleChange}
              autoComplete="new-username"
              handleBlur={handleBlurFTPInfo}
              maxLength={50}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="">
            <PasswordInput
              name="FTPPassword"
              id="FTPPassword"
              label="Password"
              // value={
              //   facilityID > 0
              //     ? facilityInformationData?.FTPPassword &&
              //     decryptData(facilityInformationData?.FTPPassword)
              //     : facilityInformationData?.FTPPassword
              // }
              value={facilityInformationData?.FTPPassword}
              handleChange={handleChange}
              placeholder="Enter Password"
              required={true}
              errorMessage={errorMessage}
              showPassword={showPassword}
              togglePasswordVisibility={togglePasswordVisibility}
              autoComplete="new-password"
              handleBlur={handleBlurFTPInfo}
              maxLength={200}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(FTPPermission);
